import axios from "axios";
import store from "../store";
import router from "../router";

const instance = axios.create({
  baseURL: "/api",
  //
  // baseURL: '/api'
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = store.state.auth.token;
    if (token) {
      // Add token to headers
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch("auth/logout");
      router.push("/login");
    }
    return Promise.reject(error);
  },
);

export default instance;
